import { Link, Typography } from "@mui/material";
import { Links } from "src/constants";
import { FeedItemDto, FeedItemTeamValueDto } from "src/http";

interface IProps {
  feedItem: FeedItemDto;
}

const TeamParentPropertyChange = (props: IProps) => {
  const parentTeam = props.feedItem.propertyChange?.value as FeedItemTeamValueDto;

  if (parentTeam == null) {
    return (
      <Typography variant="caption" sx={{ alignItems: "center" }}>
        <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
        <span> removed connected team </span>
      </Typography>
    );
  }

  return (
    <Typography variant="caption" sx={{ alignItems: "center" }}>
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
      <span> updated connected team to </span>
      <strong>
        <Link href={Links.Team(parentTeam.slug)}>{parentTeam.name}</Link>
      </strong>
    </Typography>
  );
};

export { TeamParentPropertyChange };
